import React from 'react'

export const CardFrame = (props) => (
  <div data-role={props.dataRole} className="mb-8 bg-white px-4 py-6 shadow sm:rounded-lg sm:px-6">
    {props.children}
  </div>
)
